<template>
  <div>
    <!-- Header Area -->
    <header class="main_header_area mha_2">
        <div class="container">
            <div class="header_menu">
                <nav class="navbar navbar-expand-lg">
                    <a class="navbar-brand" href="/">
                        <img src="images/logo.png" alt="Logo GPI Seguros">
                        <img src="images/logo-2.png" alt="Logo GPI Seguros">
                    </a>
                    <!-- Small Divice Menu-->
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar_supported" aria-expanded="false" aria-label="Toggle navigation">
                        <i class="fa fa-bars" aria-hidden="true"></i>
                    </button>

                    <div class="collapse navbar-collapse navbar_supported" v-if="useCreateAccount == true">
                        <ul class="navbar-nav">
                            <li><a href="/">Inicio</a></li>
                            <li><a class="active" href="/create-account">Crear cuenta</a></li>
                            <li class="apply_right"><a class="theme_btn" href="/login">Iniciar sesión</a></li>
                        </ul>
                    </div>

                    <div class="collapse navbar-collapse navbar_supported" v-else>
                        <ul class="navbar-nav">
                            <li><a href="/">Inicio</a></li>
                            <!-- <li><a class="active" href="/">Inicio</a></li> -->
                            <li><a href="/Quotation">Cotiza tu crédito</a></li>
                            <!-- <li><a href="/QuotationPanel">Crédito para panel solar</a></li>-->
                            <!--<li><a href="/credit-request">Solicita tu crédito</a></li>-->
                            <!--<li><a href="/business-partners">Socios comerciales</a></li>-->
                            <!--<li><a href="/quote-insurance">Cotiza tu seguro</a></li>-->
                            <!--<li><a href="/buy-car">Comparador de autos</a></li>-->
                            <!-- <li><a href="/contact">Contacto</a></li> -->

                            <li class="apply_right" v-if="useApplyNow === false"><a class="theme_btn" style="cursor: pointer" v-on:click="logout()">Cerrar sesión</a></li>
                            <!--<li class="apply_right" v-if="useApplyNow !== false"><a class="theme_btn" style="cursor: pointer" href="/pre-approval">Solicita tu crédito</a></li>-->

                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </header>
    <!-- Header Area -->
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    props: {
        useApplyNow: {
          type: Boolean,
          default: true
        },
        useCreateAccount:  {
          type: Boolean,
          default: false
        }
    },
    methods: {
      logout() {
        this.$SessionService.logout().then((result) => {
          localStorage.removeItem('session');
          localStorage.removeItem('id');
          localStorage.removeItem('confirmationData');
          localStorage.removeItem('quote_credit');
          location.reload();
          this.useApplyNow = true;
        }, (err) => alert(err.msg));
      }
    },
    created: function() {
      this.useApplyNow = true;
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue